import { transparentize } from 'polished'
import styled from 'styled-components'

export const BaseButton = styled.button.attrs({
  type: 'button',
})`
  box-sizing: border-box;
  height: calc(2em + 2px);
  padding: 0.375em 0.75em;
  border-color: var(--theme-border, ${props => props.borderColor});
  border-style: solid;
  border-width: 1px;
  border-radius: 0.5em;
  background-color: var(--theme-surface, ${props => props.backgroundColor});
  color: var(--theme-text, ${props => props.textColor});
  cursor: pointer;
  font-size: 1em;
  line-height: 1.25;
  outline: none;
  user-select: none;

  &:active,
  &:hover {
    background-color: var(--theme-surface-alt, #e8e8e8);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus {
    box-shadow: 0 0 0 0.2em rgba(38, 34, 98, 0.3);
  }

  svg {
    position: relative;
    top: 0.11em;
    width: 0.9em;
    height: 0.9em;
  }
`

/* stylelint-disable block-no-empty */
export const Button = styled(BaseButton).attrs({
  backgroundColor: 'var(--theme-surface, #f8f9fa)',
  borderColor: 'var(--theme-border, #6c757d)',
  textColor: 'var(--theme-text, #000)',
})``

export const PrimaryButton = styled(BaseButton).attrs({
  backgroundColor: '#262262',
  borderColor: '#262262',
  textColor: '#fff',
})`
  background-color: #262262;
  border-color: #262262;
  color: #fff;

  &:active,
  &:hover {
    background-color: #1a1845;
  }
`
/* stylelint-enable block-no-empty */

export const TextButton = styled.button.attrs({
  type: 'button',
})`
  padding: 0;
  border: none;
  background: none;
  color: var(--theme-primary, #262262);
  cursor: pointer;
  font-size: 1em;
  outline: none;
  user-select: none;

  &:active,
  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus {
    text-decoration: underline;
  }
`
